export default "__VITE_ASSET__BQ3IJiHg__";